// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AgentMarketingProfile"]);
}

function unwrap_response_switchToAgentMarketingProfile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["SwitchedToAgentMarketingProfile"]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile_AgentMarketingProfile":{"f":""},"switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile":{"u":"response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile"},"switchToAgentMarketingProfile":{"u":"response_switchToAgentMarketingProfile"}}};

let wrapResponseConverterMap = {
  response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile: RescriptRelay_Internal.wrapUnion,
  response_switchToAgentMarketingProfile: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile_AgentMarketingProfile":{"f":""},"switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile":{"u":"response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile"},"switchToAgentMarketingProfile":{"u":"response_switchToAgentMarketingProfile"}}};

let responseConverterMap = {
  response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile: unwrap_response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile,
  response_switchToAgentMarketingProfile: unwrap_response_switchToAgentMarketingProfile
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SwitchToAgentProfileDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "switchToAgentMarketingProfile",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "marketingProfile",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AgentMarketingProfileSettings_page_agentMarketingProfile"
                          }
                        ],
                        "type": "AgentMarketingProfile",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SwitchedToAgentMarketingProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SwitchToAgentProfileDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "switchToAgentMarketingProfile",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "marketingProfile",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "publicUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MarketingProfileURLDetails",
                            "kind": "LinkedField",
                            "name": "urlDetails",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "slug",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "baseUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfilePhoto",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": (v1/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "featuredPhoto",
                            "plural": false,
                            "selections": (v1/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bio",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "specialties",
                            "storageKey": null
                          }
                        ],
                        "type": "AgentMarketingProfile",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "SwitchedToAgentMarketingProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d1e6708b947a46e64ec6c37d486847f9",
    "id": null,
    "metadata": {},
    "name": "SwitchToAgentProfileDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SwitchToAgentProfileDialogMutation {\n  switchToAgentMarketingProfile {\n    __typename\n    ... on SwitchedToAgentMarketingProfile {\n      account {\n        marketingProfile {\n          __typename\n          ... on AgentMarketingProfile {\n            ...AgentMarketingProfileSettings_page_agentMarketingProfile\n          }\n          ... on Node {\n            __isNode: __typename\n            __typename\n            nodeId\n          }\n        }\n        nodeId\n      }\n    }\n  }\n}\n\nfragment AgentMarketingProfileSettings_header_agentMarketingProfile on AgentMarketingProfile {\n  publicUrl\n  ...ShareAgentMarketingProfileDialog_agentMarketingProfile\n}\n\nfragment AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile on AgentMarketingProfile {\n  profilePicture {\n    __typename\n  }\n  featuredPhoto {\n    __typename\n  }\n  bio\n  specialties\n}\n\nfragment AgentMarketingProfileSettings_page_agentMarketingProfile on AgentMarketingProfile {\n  ...AgentMarketingProfileSettings_header_agentMarketingProfile\n  ...AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile\n}\n\nfragment CopyMarketingProfileLinkButton_urlDetails on MarketingProfileURLDetails {\n  slug\n  baseUrl\n}\n\nfragment ShareAgentMarketingProfileDialog_agentMarketingProfile on AgentMarketingProfile {\n  publicUrl\n  urlDetails {\n    ...CopyMarketingProfileLinkButton_urlDetails\n  }\n}\n"
  }
};
})());

let wrap_response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile = RescriptRelay_Internal.wrapUnion;

let wrap_response_switchToAgentMarketingProfile = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile = unwrap_response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile;
exports.wrap_response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile = wrap_response_switchToAgentMarketingProfile_SwitchedToAgentMarketingProfile_account_marketingProfile;
exports.unwrap_response_switchToAgentMarketingProfile = unwrap_response_switchToAgentMarketingProfile;
exports.wrap_response_switchToAgentMarketingProfile = wrap_response_switchToAgentMarketingProfile;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
